import type { ReactNode } from "react";
import { surveyContext } from "./surveyContext";

export function SurveyProvider({ children, id }: { children: ReactNode; id: number }) {
    return <surveyContext.Provider value={{ id }}>{children}</surveyContext.Provider>;
}
